import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { childrenInstanceOf } from 'bloko/common/helpers/customPropTypes';

import 'bloko/blocks/stepwise/stepwise.less';

import StepwiseStep from './StepwiseStep';

/**
 * Предназначен для отображения списка шагов при поэтапном заполнении информации.
 */
export default function Stepwise({ children, embeddable, ...stepwiseProps }) {
    return (
        <div
            className={classnames('bloko-stepwise', {
                'bloko-stepwise_embeddable': embeddable,
            })}
            {...stepwiseProps}
        >
            <div className="bloko-stepwise__steps">{children}</div>
        </div>
    );
}

Stepwise.propTypes = {
    /** Список [StepwiseStep](/#stepwisestep) */
    children: childrenInstanceOf([StepwiseStep]),
    /** Шаги без границ */
    embeddable: PropTypes.bool,
};

Stepwise.defaultProps = {
    embeddable: false,
};

export { StepwiseStep };
